/* @flow */
import * as React from 'react';
import { withTranslation } from 'react-i18next';

import Styled from './styled';
import CoverBanner from '../../../../components/CoverBanner';
import IconButton from '../../../../components/IconButton';
import ToggleButton from '../../../../components/ToggleButton';
import WorklistHeaderForm from '../../../../forms/WorklistHeaderForm';

import type { Translate } from '../../../../types';

type Props = {
  imgSrc?: string,
  name: string,
  description?: string,
  itemsCount?: number,
  createDate: number,
  modifiedDate: number,
  onSave: () => any,
  onPublish?: () => any,
  onArchive?: () => any,
  onDelete?: () => any,
  onSelectAsWorklist1?: () => any,
  onSelectAsWorklist2?: () => any,
  isWorklist1: boolean,
  isWorklist2: boolean,
  t: Translate,
};

class WorklistHeader extends React.Component<Props, void> {
  render() {
    const {
      imgSrc,
      name,
      description,
      itemsCount,
      createDate,
      modifiedDate,
      onSave,
      onPublish,
      onArchive,
      onDelete,
      onSelectAsWorklist1,
      onSelectAsWorklist2,
      isWorklist1,
      isWorklist2,
      t,
    } = this.props;
    return (
      <CoverBanner imageSrc={imgSrc}>
        <Styled.Row>
          <Styled.DetailsColumn>
            <WorklistHeaderForm
              initialValues={{
                name: name || t('WORKLIST'),
                description: description || t('NO_DESCRIPTION'),
              }}
            />
            <div>
              <b>{t('CREATE_DATE')}:</b>{' '}
              {t('DATETIME_FORMAT', { timestamp: createDate ? createDate : Date.now() })}
            </div>
            <div>
              <b>{t('MODIFIED_DATE')}:</b>{' '}
              {t('DATETIME_FORMAT', { timestamp: modifiedDate ? modifiedDate : Date.now() })}
            </div>
            <div>
              <b>{t('ITEMS_COUNT')}:</b> {itemsCount ? itemsCount : 0}
            </div>
          </Styled.DetailsColumn>
          <Styled.ActionsColumn>
            {!!onSelectAsWorklist1 && (
              <ToggleButton
                icon={'worklist_1'}
                tooltip={isWorklist1 ? t('SELECTED_AS_WL1') : t('SELECT_AS_WL1')}
                disabled={!isWorklist1}
                onClick={onSelectAsWorklist1}
                label={t('SELECT_AS_WL1')}
              />
            )}
            {!!onSelectAsWorklist2 && (
              <ToggleButton
                icon={'worklist_2'}
                tooltip={isWorklist2 ? t('SELECTED_AS_WL2') : t('SELECT_AS_WL2')}
                disabled={!isWorklist2}
                onClick={onSelectAsWorklist2}
                label={t('SELECT_AS_WL2')}
              />
            )}
            {!!onSave && (
              <IconButton icon={'save'} tooltip={t('SAVE')} label={t('SAVE')} onClick={onSave} />
            )}
            {!!onPublish && (
              <IconButton
                icon={'share'}
                tooltip={t('PUBLISH')}
                label={t('PUBLISH')}
                onClick={onPublish}
              />
            )}
            {!!onArchive && (
              <IconButton
                icon={'archive'}
                tooltip={t('ARCHIVE')}
                label={t('ARCHIVE')}
                onClick={onArchive}
              />
            )}
            {!!onDelete && (
              <IconButton
                icon={'trash'}
                tooltip={t('DELETE')}
                label={t('DELETE')}
                onClick={onDelete}
              />
            )}
          </Styled.ActionsColumn>
        </Styled.Row>
      </CoverBanner>
    );
  }
}
export default withTranslation()(WorklistHeader);
